export enum EstadoPagoEnum {
    pendiente = 1,
    pagado = 2,
    cancelado = 3
}